"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoppingForHeaderSection = exports.ShoppingFor = void 0;
const react_1 = require("@headlessui/react");
const classnames_1 = __importDefault(require("classnames"));
const react_2 = __importDefault(require("react"));
function ShoppingFor(_a) {
    var { customId, children, className } = _a, props = __rest(_a, ["customId", "children", "className"]);
    return (react_2.default.createElement(react_1.Tab.Group, null,
        react_2.default.createElement("div", Object.assign({ className: (0, classnames_1.default)('bg-white max-w-screen-2xl mx-auto font-sofia px-4 py-6 md:py-8 text-gray', className) }, props),
            react_2.default.createElement("div", { id: customId, className: "w-full" }, children))));
}
exports.ShoppingFor = ShoppingFor;
const ShoppingForHeaderSection = ({ headerText, }) => (react_2.default.createElement(react_2.default.Fragment, null,
    react_2.default.createElement("h2", { className: "w-full lg:w-auto text-2xl md:text-3xl xl:text-4xl text-center px-4 mb-4 sm:mb-6 xl:mb-8" }, headerText)));
exports.ShoppingForHeaderSection = ShoppingForHeaderSection;
ShoppingFor.TabList = ({ children, className }) => {
    return (react_2.default.createElement(react_1.Tab.List, { className: (0, classnames_1.default)('flex justify-evenly w-full sm:w-auto sm:justify-center mb-6 sm:mb-8', className) }, children));
};
ShoppingFor.TabPanels = ({ children, className }) => {
    return react_2.default.createElement(react_1.Tab.Panels, { className: className }, children);
};
ShoppingFor.TabPanel = ({ children, className }) => {
    return (react_2.default.createElement(react_1.Tab.Panel, { className: (0, classnames_1.default)('xl:pt-4 grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-4 md:gap-6 xl:gap-12 solid-focus-ring', className) }, children));
};
ShoppingFor.Option = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (react_2.default.createElement(react_1.Tab, { as: react_2.default.Fragment }, ({ selected }) => (react_2.default.createElement("button", Object.assign({ className: (0, classnames_1.default)('p-2 border-1 border-yellow rounded-[5px] text-sm md:text-base xl:text-xl sm:px-6 sm:mx-3 lg:mx-6 image-link-focus-ring', {
            'border-[3px]': selected,
        }, className) }, props), children))));
};
ShoppingFor.Link = (_a) => {
    var { children, destinationURL, imageURL, className } = _a, props = __rest(_a, ["children", "destinationURL", "imageURL", "className"]);
    return (react_2.default.createElement("a", Object.assign({ href: destinationURL, className: (0, classnames_1.default)('group w-full rounded-2xl grid place-content-center text-white relative overflow-hidden bg-black image-link-focus-ring', className), style: { aspectRatio: '1/1' } }, props),
        react_2.default.createElement("span", { className: "absolute block opacity-60 inset-0 transition-transform scale-100 group-hover:scale-110 ", style: {
                backgroundImage: `url(${imageURL})`,
                backgroundSize: 'cover',
                backgroundPosition: '50% 50%',
            }, "aria-hidden": "true" }),
        react_2.default.createElement("p", { className: "relative text-center px-4 sm:text-2xl xl:text-3xl" }, children)));
};
